module.exports = __webpack_public_path__ + "img/cc3623_center_001.9219aee0.png";